import { Component } from '@angular/core'

@Component({
  selector: 'se-po-parent-contact-info-docs',
  templateUrl: './parent-contact-info-docs.component.html',
  styleUrls: ['./parent-contact-info-docs.component.scss'],
  standalone: false,
})
export class ParentContactInfoDocsComponent {
  public models: string[]
  public headers: any = {
    ParentContactInfoComponent: [
      'Property',
      'Type',
      'Description',
    ],
  }
  public rows: any = {
    ParentContactInfoComponent: [
      {
        Property: '@Input() persona',
        Type: 'Persona | AccountInfo',
        Description: 'Parent\'s persona or account info object',
      }
    ]
  }

  constructor() {
    this.models = Object.keys(this.headers)
  }
}
